/** Tiendas de la app de la clienta (`com.kabandu.kabanduApp`). */
export const APP_STORE_URL = 'https://apps.apple.com/mx/app/kabandu/id6747091586';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.kabandu.kabanduApp';
const ANDROID_PACKAGE = 'com.kabandu.kabanduApp';

export type Plataforma = 'ios' | 'android' | 'otra';

export const detectarPlataforma = (): Plataforma => {
    const ua = navigator.userAgent || '';
    if (/android/i.test(ua)) return 'android';
    // Desde iPadOS 13 Safari se anuncia como Mac: se distingue por la pantalla táctil.
    if (/iPad|iPhone|iPod/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1)) return 'ios';
    return 'otra';
};

/**
 * Link que abre la app en Android desde el navegador. Un link normal a este mismo dominio no la
 * abre (el sistema solo intercepta los que llegan de FUERA, como el de WhatsApp); el `intent://`
 * sí. Si la app no está o es una versión que no conoce ese link, Chrome cae a Play.
 */
export const intentAndroid = (path: string): string =>
    `intent://app.kabandu.com${path}#Intent;scheme=https;package=${ANDROID_PACKAGE};` +
    `S.browser_fallback_url=${encodeURIComponent(PLAY_STORE_URL)};end`;
